import React from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Box, Text } from '@chakra-ui/react'
import { Form, Field } from 'react-final-form'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import Loader from 'src/components/Loader/Loader'
import { hasFeatureFlag } from 'src/utils/helpers'
import { postRequest } from 'src/utils/request-client'
import withToast from 'src/components/Toast'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import EmailConfirmation from 'src/modals/EmailConfirmation/index'

import './UserAdd.module.less'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'

import { validateEmail } from 'src/utils/validation'

class UserAdd extends React.Component {
  state = {
    loading: false,
    showEmailConfirmation: false,
  }

  componentDidMount() {
    const { user, history, featureFlags } = this.props

    // TODO: Figure out better way to disable these actions for sub-users
    // Redirect to home page if logged in as sub-user
    if (user && user.hasOwnProperty('vuaId') && user.vuaId) {
      history.push('/')
    }

    // Redirect to home page if feature flag not enabled
    if (!hasFeatureFlag(featureFlags, 'users.manage.viewAddRemove') && history) {
      history.push('/')
    }
  }

  handleSubmit = values => {
    const { intl, afterAddUser, toast } = this.props

    postRequest(
      {
        base: '/users/vaultUserAccountAdd',
        mock: false,
      },
      values,
    )
      .then(response => {
        if (response && response.error) {
          this.setState(
            {
              loading: false,
            },
            () => {
              toast({
                title: intl.formatMessage(intlMessagesApp.appErrorTitle),
                description: response.error,
                status: 'error',
              })
            },
          )
        } else {
          this.setState(
            {
              loading: false,
              showEmailConfirmation: values.email,
            },
            () => {
              if (typeof afterAddUser === 'function') {
                afterAddUser()
              }
            },
          )
        }
      })
      .catch(e => {
        this.setState(
          {
            loading: false,
            showEmailConfirmation: false,
          },
          () => {
            toast({
              title: intl.formatMessage(intlMessagesApp.appErrorTitle),
              description: e.error || e.toString(),
              status: 'error',
            })
          },
        )
      })
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}

    if (!values.firstName) {
      errors.firstName = intl.formatMessage(intlMessages.validationFirstNameRequired)
    }
    if (!values.lastName) {
      errors.lastName = intl.formatMessage(intlMessages.validationLastNameRequired)
    }

    if (!values.email) {
      errors.email = intl.formatMessage(intlMessages.validationEmailRequired)
    }

    if (values.email && !validateEmail(values.email)) {
      errors.email = intl.formatMessage(intlMessages.validationEmailNotValid)
    }

    return errors
  }

  closeEmailConfirmation = () => {
    const { history } = this.props

    this.setState({
      showEmailConfirmation: false,
    })

    history.push('/users')
  }

  renderConfirmationContent = () => {
    const { showEmailConfirmation } = this.state

    if (!showEmailConfirmation) return

    return (
      <Text>
        <FormattedMessage
          id='app.users.addUserConfirmation.part1'
          defaultMessage='We have sent email to {email} to confirm the validity of email address. New user will be activated as soon as email is confirmed.'
          values={{
            email: showEmailConfirmation,
          }}
        />
      </Text>
    )
  }

  render() {
    const { loading, showEmailConfirmation } = this.state
    const { intl } = this.props

    return (
      <Layout>
        <Content>
          <PageTitle
            subtitle={intl.formatMessage(intlMessages.usersHeadline)}
            title={intl.formatMessage(intlMessages.usersAddUser)}
          />
          <Container padder className='global-centered-desktop-content'>
            {loading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <Box pt={'20px'}>
                <Form
                  onSubmit={this.handleSubmit}
                  validate={this.validateFormFields}
                  render={({ handleSubmit }) => {
                    return (
                      <form onSubmit={handleSubmit}>
                        <Field
                          name='firstName'
                          render={({ input, meta }) => (
                            <Box mb={2}>
                              <Input
                                placeholder={intl.formatMessage(intlMessages.placeholderFirstName)}
                                error={meta}
                                name='firstName'
                                {...input}
                              />
                            </Box>
                          )}
                        />
                        <Field
                          name='lastName'
                          render={({ input, meta }) => (
                            <Box mb={2}>
                              <Input
                                placeholder={intl.formatMessage(intlMessages.placeholderLastName)}
                                error={meta}
                                name='lastName'
                                {...input}
                              />
                            </Box>
                          )}
                        />
                        <Field
                          name='email'
                          render={({ input, meta }) => (
                            <Box mb={2}>
                              <Input
                                placeholder={intl.formatMessage(intlMessages.placeholderEmail)}
                                error={meta}
                                name='email'
                                {...input}
                              />
                            </Box>
                          )}
                        />
                        <Button mt={'20px'} isFullWidth type='submit'>
                          <FormattedMessage id='app.global.action.add' defaultMessage='Add User' />
                        </Button>
                      </form>
                    )
                  }}
                />
              </Box>
            )}

            <EmailConfirmation
              visible={showEmailConfirmation}
              onClose={this.closeEmailConfirmation}
              renderContent={this.renderConfirmationContent()}
              onConfirm={this.closeEmailConfirmation}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(UserAdd)))
